export class Contact {
    public ContactType!: string;
    public ContactData!: string;
    public IssueFulfillment!: boolean;
    public FulfillmentLanguage!: string;

    constructor(){       
    }
}